export default __webpack_public_path__ + "static/media/file_blank_image.823f891c.webp";